import { createAction } from 'redux-actions';

import {
  SHOW_VISIBLE_COMPONENTS_TAB_INFO,
  SHOW_VISIBLE_COMPONENTS_TAB_CHAPTERS,
  SHOW_VISIBLE_COMPONENTS_TAB_FILES,
  SHOW_VISIBLE_COMPONENTS_TAB_AUDIO,
  SHOW_VISIBLE_COMPONENTS_TAB_SHARE,
  SHOW_VISIBLE_COMPONENTS_TAB_TRANSCRIPTS,
  SHOW_VISIBLE_COMPONENTS_HEADER_POSTER,
  SHOW_VISIBLE_COMPONENTS_HEADER_TITLE,
  SHOW_VISIBLE_COMPONENTS_HEADER_EPISODE,
  SHOW_VISIBLE_COMPONENTS_HEADER_SUBTITLE,
  SHOW_VISIBLE_COMPONENTS_CONTROLS_STEPPER,
  SHOW_VISIBLE_COMPONENTS_CONTROLS_CHAPTERS,
  SHOW_VISIBLE_COMPONENTS_CONTROLS_PROGRESSBAR,
  HIDE_VISIBLE_COMPONENTS_TAB_INFO,
  HIDE_VISIBLE_COMPONENTS_TAB_CHAPTERS,
  HIDE_VISIBLE_COMPONENTS_TAB_FILES,
  HIDE_VISIBLE_COMPONENTS_TAB_AUDIO,
  HIDE_VISIBLE_COMPONENTS_TAB_SHARE,
  HIDE_VISIBLE_COMPONENTS_TAB_TRANSCRIPTS,
  HIDE_VISIBLE_COMPONENTS_HEADER_POSTER,
  HIDE_VISIBLE_COMPONENTS_HEADER_TITLE,
  HIDE_VISIBLE_COMPONENTS_HEADER_EPISODE,
  HIDE_VISIBLE_COMPONENTS_HEADER_SUBTITLE,
  HIDE_VISIBLE_COMPONENTS_CONTROLS_STEPPER,
  HIDE_VISIBLE_COMPONENTS_CONTROLS_CHAPTERS,
  HIDE_VISIBLE_COMPONENTS_CONTROLS_PROGRESSBAR,
  TOGGLE_VISIBLE_COMPONENTS_EXTENDED_BLOCK,
} from './types';

// Tabs
export const showInfoTab = createAction(SHOW_VISIBLE_COMPONENTS_TAB_INFO);
export const hideInfoTab = createAction(HIDE_VISIBLE_COMPONENTS_TAB_INFO);
export const showChaptersTab = createAction(SHOW_VISIBLE_COMPONENTS_TAB_CHAPTERS);
export const hideChaptersTab = createAction(HIDE_VISIBLE_COMPONENTS_TAB_CHAPTERS);
export const showFilesTab = createAction(SHOW_VISIBLE_COMPONENTS_TAB_FILES);
export const hideFilesTab = createAction(HIDE_VISIBLE_COMPONENTS_TAB_FILES);
export const showAudioTab = createAction(SHOW_VISIBLE_COMPONENTS_TAB_AUDIO);
export const hideAudioTab = createAction(HIDE_VISIBLE_COMPONENTS_TAB_AUDIO);
export const showShareTab = createAction(SHOW_VISIBLE_COMPONENTS_TAB_SHARE);
export const hideShareTab = createAction(HIDE_VISIBLE_COMPONENTS_TAB_SHARE);
export const showTranscriptsTab = createAction(SHOW_VISIBLE_COMPONENTS_TAB_TRANSCRIPTS);
export const hideTranscriptsTab = createAction(HIDE_VISIBLE_COMPONENTS_TAB_TRANSCRIPTS);

// Header
export const showInfoPoster = createAction(SHOW_VISIBLE_COMPONENTS_HEADER_POSTER);
export const hideInfoPoster = createAction(HIDE_VISIBLE_COMPONENTS_HEADER_POSTER);
export const showShowTitle = createAction(SHOW_VISIBLE_COMPONENTS_HEADER_TITLE);
export const hideShowTitle = createAction(HIDE_VISIBLE_COMPONENTS_HEADER_TITLE);
export const showEpisodeTitle = createAction(SHOW_VISIBLE_COMPONENTS_HEADER_EPISODE);
export const hideEpisodeTitle = createAction(HIDE_VISIBLE_COMPONENTS_HEADER_EPISODE);
export const showSubtitle = createAction(SHOW_VISIBLE_COMPONENTS_HEADER_SUBTITLE);
export const hideSubtitle = createAction(HIDE_VISIBLE_COMPONENTS_HEADER_SUBTITLE);

// Controls
export const toggleExtendedBlock = createAction(TOGGLE_VISIBLE_COMPONENTS_EXTENDED_BLOCK);
export const showChapterControls = createAction(SHOW_VISIBLE_COMPONENTS_CONTROLS_CHAPTERS);
export const hideChapterControls = createAction(HIDE_VISIBLE_COMPONENTS_CONTROLS_CHAPTERS);
export const showSteppersControls = createAction(SHOW_VISIBLE_COMPONENTS_CONTROLS_STEPPER);
export const hideSteppersControls = createAction(HIDE_VISIBLE_COMPONENTS_CONTROLS_STEPPER);
export const showProgressBar = createAction(SHOW_VISIBLE_COMPONENTS_CONTROLS_PROGRESSBAR);
export const hideProgressBar = createAction(HIDE_VISIBLE_COMPONENTS_CONTROLS_PROGRESSBAR);
